import React from 'react';

// LangContext is used in CrystalProvider
export var LangContext = /*#__PURE__*/React.createContext('en-US');
export function useLang() {
  return React.useContext(LangContext);
}